export const getStartOfMonth = (date)=>{
   return new Date(date.getFullYear(), date.getMonth(), 1);
  }